import PerformanceByTerritoryCard from "../PerformanceByTerritory/PerformanceByTerritoryCard";
import {
  NATIONAL_PERFORMANCE_TEXT,
  PERFORMANCE_BENCHMARK_TOOLTIP_TEXT,
} from "../PerformanceByTerritory/performanceTextConstants";

export default function NationalPerformanceCard({
  rows = [],
  isLoading = false,
  onExplore,
}) {
  return (
    <PerformanceByTerritoryCard
      title={NATIONAL_PERFORMANCE_TEXT.title}
      titleTooltipText={PERFORMANCE_BENCHMARK_TOOLTIP_TEXT}
      subtitle={NATIONAL_PERFORMANCE_TEXT.subtitle}
      rows={rows}
      isLoading={isLoading}
      onExplore={onExplore}
    />
  );
}
